import React from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { AUTH_LEVELS } from '../auth/Authorized';
import getBuildingsOrderedByName from '../../redux/selectors/buildings';
import ResultsView from './ResultsView';
import AssetTile from './assetTile/AssetTile';
import SummaryTable from './summarytable/SummaryTable';
import BuildingsLoader from './BuildingsLoader';

const BuildingsContainer = (props) => {
  const navigate = useNavigate();
  const handleSelection = (e, building) => {
    const url = `/explore/buildings/${building.name}?bid=${building.id}`;
    navigate(url);
  };
  const buildingResults = props.buildings.map((building) => (
    <AssetTile
      key={building.id}
      frontTitle={building.name}
      frontSubtitle={props.showStatus && building.status}
      frontDrilldownFunc={(e) => handleSelection(e, building)}
      frontDrilldownEnabled
      flipEnabled
      flipLabel="Quick View >"
      backTileContent={
        <SummaryTable
          table={{
            title: '',
            cols: [
              { hideOnMobile: false, name: '' },
              { hideOnMobile: false, name: '' },
            ],
            rows: [
              {
                id: 0,
                values: ['Address', building.address || ''],
              },
              {
                id: 1,
                values: ['Sq. ft.', building.sqFt?.toLocaleString() || ''],
              },
              {
                id: 2,
                values: ['Equipment', `${building.equipCount || ''}`],
              },
              {
                id: 3,
                values: ['Points', `${building.pointCount?.toLocaleString() || ''}`],
              },
            ],
          }}
        />
      }
    />
  ));

  return (
    <>
      <BuildingsLoader />
      <ResultsView loading={props.isLoading} results={buildingResults} />
    </>
  );
};

export default connect((state) => ({
  buildings: getBuildingsOrderedByName(state),
  isLoading: state.entities.buildings.meta.isLoading,
  showStatus: state.user.userAuthLevel <= AUTH_LEVELS.SUPER_ADMIN,
}))(BuildingsContainer);
